<template>
         <div class="" id='viewRealTimeLogsDetail' style="height:200px;"   v-show="viewCurrent==viewIndex">
             
               <div class="realTimeDetailBody" style="padding:0px;marginTop:10Px;" v-if="viewTask">
                 
                    <div  style="color:#6f7886;lineHeight:18Px;width:100%;height:50Px;marginBottom:15Px;">
                    
                    <div style="width:100%" class="logs-realTime-box progress-box-height" v-for="(item, index) in viewTask" :key="index"  :class="getHeight(item,index)">
                    <div class="view-logs-realTime-info"  style="width:100%">
                        <!-- <div style="width:190Px;float:left;fontSize:10px;">
                        {{$t('language.common.startTime')}}:{{item.taskStartTimeStr}}
                        </div>
                        <div style="float:left;fontSize:10px;">
                         {{$t('language.common.endTime')}}:{{item.lastSyncTime}}
                        </div> -->
                         <div style="width:210Px;float:left;font-size:12px;">
                             <div class="view-logs-catelog"  style="font-size:12px;">
                                <div style="float:left;">{{$t('language.common.from')}}:</div>
                                <div class="view-logs-category-link"  @click.stop="toSourceCatalog(item.fromItem)" :title="item.fromItem.nodes|getCatalog|getCatalogTitle">{{item.fromItem.nodes|getCatalog}}</div>
                            </div>
                            <div class="view-logs-catelog" style="font-size:12px;">
                                <div style="float:left;">{{$t('language.common.with')}}:</div>
                                <div class="view-logs-category-link" @click.stop="toAimCatalog(item.toItem)" :title="item.toItem.nodes|getCatalog|getCatalogTitle">{{item.toItem.nodes|getCatalog}}</div>
                            </div>
                        </div>
                        <div style="float:left;height:100%;textAlign:right;lineHeight:37Px;position:relative;left:30px;">
                            <div v-if="item.lastLog.newLog[viewIndex] && item.lastLog.newLog[viewIndex].response=='success'">
                                <div class="icon-util task-success logs-failure-icon-position"></div>
                               <div style="float:left;">success</div>
                              
                            </div>
                             <div v-if="item.lastLog.newLog[viewIndex] && item.lastLog.newLog[viewIndex].response=='error'">
                                <div class="icon-util task-failure logs-failure-icon-position"></div>
                               <div  style="float:left;">{{$t('language.common.failure')}}</div>
                            </div>
                             <div v-if="item.lastLog.newLog[viewIndex] && item.lastLog.newLog[viewIndex].response=='cancel'">
                                <div class="icon-util task-failure logs-failure-icon-position"></div>
                               <div  style="float:left;">{{$t('language.common.cancel')}}</div>
                            </div>
                          
                            
                        </div>
                        <div class="icon-util  view-collapse-positopn" :class="clickCurrent == index?'collapse-up':'collapse-down'" @click="collapse(index,item)"> </div>
                        <viewlogsDetail  ref="viewlogsDetail" :clickCurrent=clickCurrent :index=index :itemDetail='item.lastLog.newLog[viewIndex]' :allItem='item' :isShow="isShow"> </viewlogsDetail>
                    </div>
                    </div>

                    </div>

               </div>
                <!-- <div v-if="viewTask.lastLog.newLog.length>=200"  style="position:absolute;bottom:-50px;color:red;">{{$t('language.cloudSync.reachMax')}}</div> -->
         </div>
</template>

<script>
import taskListUtils from "@/js/workspace/task_list_util.js";
import viewlogsDetail from "@/components/common/tabs/tabs_task_list/tab_realTime_logs";
import commonUtils from "@/js/workspace/common_util.js";
export default {
     props: ['viewCurrent', 'viewIndex','viewTask'],
      data:function(){
           return{
               realtimeLogsShow:false,
               viewDetail:{},
               nonFlag:false,
               realTimeDetailBodyShow:false,
               loading:false,
               clickCurrent:-1,
               aimsMoresFlag:false,//标识是否是多目标的传输目录
               isShow:false
           }
      },
      components:{
             viewlogsDetail
      },
      mounted(){
         
      },
      methods:{
            showStatus(item){
            let result=taskListUtils.showStatus(item);
            return result;
        },
          getDataProcessTitle(value){
              let str1=commonUtils.formatByte(value.lastLog.fileTotalReadedBytes);
              return str1;
          },
           closePage(){
               this.realtimeLogsShow=false;
               this.realTimeDetailBodyShow=false;
           },
          toAimCatalog(item) {
            this.$parent.toAimCatalog(item);
          },
           toSourceCatalog(item) {
            this.$parent.toSourceCatalog(item);
           },
            openFailedFiles() {
            let that = this;
            let failedFilesDialog = this.$parent.$refs.failedFilesDialog;
            let errorList = this.viewDetail.tasks[0].lastLog.errorList;
            let task = that.viewDetail.tasks[0];
            failedFilesDialog.transferType = this.viewDetail.type;
            failedFilesDialog.selectedArr = [];
            failedFilesDialog.unfinishData = Object.assign([], errorList);
            $.each(failedFilesDialog.unfinishData, function (index, item) {
                item.fromItem = Object.assign([], task.fromItem);
                item.toItem = Object.assign([], task.toItem);
                item.options = task.options;
            });
            that.$forceUpdate();
            failedFilesDialog.retryFailedShow = true;
        },
        getAvgSpeed(value){
           let interval=(value.lastLog.fileTotalReadedBytes/(value.lastLog.taskElaspedTimeLong/1000));
           return this.Utils.formatByteSpeed(interval);
        },
           getHeight(item,index){
            if(this.clickCurrent==index){
            if(item.type!=1){
                if(!this.isShow){
                     return 'viewLog-real-txt';
                }
             return 'viewLog-real-more';
            }else{
                if(item.getViewLogCount&&item.getViewLogCount!=1){
                    return 'viewLog-box-min';
                }
                 return 'viewLog-box-more';
            }
            }else{
                return false;
            }
        },
            collapse(index,item) {
            //console.log(item);
            let that=this;
            if (this.clickCurrent != index) {
                this.clickCurrent = index;
                if(!item.lastLog){
                   let  getData = new taskListUtils.getTasks(commonUtils.getUser().id, item.type, item.id, null);
                    this.Utils.doTasksRequest("get", getData).then(result => {
                        if (result.status == 200) {
                            if(!item.getViewLogCount){
                                    item.getViewLogCount=0;
                                }
                            item.getViewLogCount=item.getViewLogCount+1;
                            if(result.tasks[0].lastLog){
                                item.lastLog=result.tasks[0].lastLog;
                            }
                              that.viewDetail.tasks[index]=item;
                                Vue.set(that.viewDetail.tasks, index, item);
                                that.$nextTick(()=>{
                                   that.$refs.viewlogsDetail[index].updatePage(item);
                                })
                                that.$forceUpdate();
                        }
                    });
                }
            } else {
                this.clickCurrent = -1;
            }
        },
      }
}
</script>

<style>
#viewRealTimeLogsDetail{
  
    height: 350px;
    /*no*/
    font-size: 12Px;
}

.realTimeDetailBody{
     padding: 15px;
    /*no*/
    width: 100%;
    height: 180Px;
    /*no*/
    box-sizing: border-box;
    overflow: auto;
    position: relative;
}
.realTimeDetailBody::-webkit-scrollbar {
    width: 8px;
    /*no*/
    height: 5px;
    /*no*/
    background-color: rgba(0, 0, 0, 0);
}

.realTimeDetailBody::-webkit-scrollbar-thumb {
    border-radius: 5px;
    /*no*/
    background-color: #becae4;
}
.sync_detail{
    font-weight: bold;
    font-size: 14Px !important;
    margin-bottom:20Px;
}
.detail_txt{
    font-size: 14Px;
    color: #6f7886;
    margin-bottom: 5Px;
    float: left;
}
.catalog{
    margin-bottom: 20Px;
    width: 100%;
    margin-bottom: 20Px;
    height: 40Px;
}
.log-line {
    width: 100%;
    float: left;
}
.realtime-category-link {
    color: #4281ff;
    float: left;
    max-width: 400px;
    /*no*/
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.view-logs-category-link {
    color: #4281ff;
    float: left;
    width: 160px;
    /*no*/
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.realtime-category-link:hover,
.view-logs-category-link:hover {
    color: #4281ff;
    text-decoration: underline;
    cursor: pointer;
}
.log-realTimeline-left{
    float: left;
    width: 255px;
    /*no*/
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.view-logs-realTime-info{
    width: 500px;
    /*no*/
    height: 40px;
    /*no*/
    position: absolute;
    z-index: 3;
    font-size: 14px;
    /*no*/
    box-sizing: border-box;
    padding: 0px 10px 0px 10px;
    /*no*/
     font-family: Arial, "Microsoft YaHei", 微软雅黑;
}

.view-reallogs-all {
    width: 100%;
    height: 300px;
    /*no*/
    overflow: auto;
}

/*定义滑块，内阴影及圆角*/

.view-reallogs-all::-webkit-scrollbar {
    width: 8px;
    /*no*/
    height: 8px;
    /*no*/
    background-color: #fff;
}

.view-reallogs-all::-webkit-scrollbar-thumb {
    border-radius: 5px !important;
    /*no*/
    background-color: #becae4 !important;
    display: block !important;
}

@-webkit-keyframes rotation {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
  }
}

.Rotation {
  -webkit-transform: rotate(360deg);
  animation: rotation 3s linear infinite;
  -moz-animation: rotation 3s linear infinite;
  -webkit-animation: rotation 3s linear infinite;
  -o-animation: rotation 3s linear infinite;
}
.logs-realTime-box{
     width: 500px;
    /*no*/
    border: 1px solid #cdddf5;
    /*no*/
    position: relative;
    line-height: 40px;
    /*no*/
    margin-bottom: 10px;
    /*no*/
    box-sizing: border-box;
}
.realtime-logs-position{
    float: left;
    top:9Px !important;
    margin-right:8Px;
}
.viewLog-real-txt{
  height: 190Px;
}
</style>


// WEBPACK FOOTER //
// src/components/common/tabs/tabs_task_list/tab_singleLogs_sync_detail.vue